
import Konva from "konva";
import { Global } from "../utilities/global";
import { DrawFence } from './DrawFence';
import { Shape } from "./ShapeInterface";

export class FenceRectangle implements Shape {

	x: number;
	y: number;
	width: number;
	height: number;
	toolTip: any;

	drawShape(start: any, end: any, name: string, point: any = []): any {
		DrawFence.FenceCount++;
		var shape: Konva.Line = new Konva.Line({
			points: start ? [start.x, start.y, end.x, start.y, end.x, end.y, start.x, end.y] : point,
			stroke: '#ffffff',
			strokeWidth: 0,
			fill: DrawFence.fillColor,
			draggable: true,
			closed: true,
			name: Global.nonUsableArea,
			id: Global.fence + DrawFence.FenceCount
		});

		return shape;
	}


}